import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';

interface MEditButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const MEditButton = ({ onClick, disabled, className }: MEditButtonProps) => {
  return (
    <Button
      variant='text'
      startIcon={<EditIcon fontSize='small' />}
      onClick={onClick}
      disabled={disabled}
      className={className}>
      Edit
    </Button>
  );
};
